import Storage from 'services/storage2';
import Http from 'services/http2';

const EnumService = {
  //多级联动的枚举接口过滤
  filter(data: any[], filterValue: string) {
    if (filterValue === '') {
      return data;
    } else {
      let arr: any[] = [];
      data.forEach(item => {
        if (item.filterValue === filterValue) {
          arr.push(item);
        }
      });
      return arr;
    }
  },

  /**
   * 获取枚举值
   * @param mainKey 主键值
   * @param subKey  枚举值
   * @returns
   */
  async getValue(mainKey: string, subKey: string) {
    let value = '';
    subKey += '';
    if (mainKey.trim() === '' || subKey.trim() === '') {
      return value;
    }
    await this.getList(mainKey).then(list => {
      list = list || [];
      for (let i = 0, j = list.length; i < j; i += 1) {
        if (list[i].subKey === subKey) {
          value = list[i].subValue;
          break;
        }
      }
    });
    return value;
  },

  getValueFromList(subKey, list: any[] = []) {
    let value = '';
    subKey += '';
    if (list.length === 0 || subKey.trim() === '') {
      return value;
    }
    for (let i = 0, j = list.length; i < j; i += 1) {
      if (list[i].subKey === subKey) {
        value = list[i].subValue;
        break;
      }
    }
    return value;
  },

  /**
   * 获取枚举列表原始数据
   * @param mainKey     主键值
   * @param filterValue 过滤项
   * @returns
   */
  async getList(mainKey: string, filterValue: string = '') {
    let data: any = [];
    if (typeof mainKey === 'string' && mainKey.trim() === '') {
      return data;
    }
    let cache: any = Storage.getItem(mainKey);
    if (cache === null) {
      let postbody = {
        mainKey,
        isShow: 1,
        filterValue: '', //不使用服务端过滤是为了便于缓存控制
        apiPath: '/oss/enum/list'
      };
      await Http.post('/api/cloudCenter', postbody).then(response => {
        if (response.success) {
          data = response.data;
          Storage.setItem(mainKey, data);
        }
      });
      return this.filter(data, filterValue);
    }
    return this.filter(cache, filterValue);
  },

  /**
   * 获取下拉选单数据
   *
   * @description       后端db中字段为int类型，但下发的枚举值为string类型，所以此处进行转换，保持和DB一致。
   *                    但各别枚举字段对应的DB字段是string类型，应避免调用此方法。如：地区码 '0086'。
   *
   * @param mainKey     主键值
   * @param [ignorList] 忽略项数组
   *
   */
  async getItems(mainKey: string, ignorList?: number[]) {
    let list = (await this.getList(mainKey)) || [];
    let arr: any[] = [];
    list.forEach(item => {
      let subKey = Number(item.subKey);
      if (ignorList && ignorList.includes(subKey)) {
        return;
      }
      let obj = {
        id: subKey,
        text: item.subValue
      };
      arr.push(obj);
    });
    return arr;
  }
};

export default EnumService;
